import { render, staticRenderFns } from "./_gameResult.vue?vue&type=template&id=280e8be0&scoped=true&lang=pug&"
import script from "./_gameResult.vue?vue&type=script&lang=js&"
export * from "./_gameResult.vue?vue&type=script&lang=js&"
import style0 from "./_gameResult.vue?vue&type=style&index=0&id=280e8be0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "280e8be0",
  null
  
)

export default component.exports